var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video_wrapper",style:({zIndex: _vm.zIndex})},[_c('video',{ref:"video",attrs:{"playsinline":"1","preload":"auto","disablePictureInPicture":""},domProps:{"muted":_vm.autoplaying}})])}
var staticRenderFns = []

export { render, staticRenderFns }